<template>
  <!-- Page title -->
  <div class="page-title py-5 bg-custom-gradient position-relative">
    <div class="container">
      <div class="d-lg-flex d-none flex-lg-row flex-column align-items-lg-center align-items-start justify-content-between">
        <div><h3 class="text-white fw-bold">الملف الشخصي</h3></div>
        <form class="search-form">
          <div class="d-flex flex-column flex-lg-row gap-3">
            <div class="position-relative">
              <div class="form-icon start">
                <i class="fa fa-search text-white"></i>
              </div>
              <input type="text" class="form-control bg-transparent text-white border-2 border-white" placeholder="البحث .." />
            </div>
          </div>
        </form>
      </div>

      <!-- User -->
      <div class="user d-flex align-items-center justify-content-center flex-column position-absolute top-100 start-50 translate-middle">
        <div class="avatar mt-lg-0 mt-5 position-relative">
          <img src="@/assets/images/msaaq.svg" width="152" alt="" />
          <div>
            <label for="avatar" role="button" class="text-white position-absolute bottom-0 start-50 translate-middle">تعديل</label>
            <input type="file" id="avatar" class="form-control d-none" />
          </div>
        </div>
        <div class="d-flex align-items-center mt-4">
          <div class="fs-4 text-primary fw-bold me-2">مساق</div>
          <button class="btn icon-btn bg-primary bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center p-3">
            <div class="svg-icon">
              <svg id="icons_Pencil_Line" data-name="icons/Pencil/Line" xmlns="http://www.w3.org/2000/svg" width="19.894" height="19.894" viewBox="0 0 19.894 19.894">
                <path
                  id="Shape"
                  d="M.074,16.241.8,12.98a4,4,0,0,1,1.076-1.961l9.848-9.848a4,4,0,0,1,5.657,0l1.343,1.343a4,4,0,0,1,0,5.657L8.875,18.02A4,4,0,0,1,6.914,19.1l-3.261.725A3,3,0,0,1,.074,16.241Zm2.677-2.827-.725,3.261a1,1,0,0,0,1.193,1.193l3.261-.725a2,2,0,0,0,.949-.508L3.258,12.465A2,2,0,0,0,2.751,13.414ZM4.672,11.05l4.172,4.172,5.586-5.586L10.258,5.465ZM17.308,6.757,15.844,8.222,11.672,4.05l1.465-1.465a2,2,0,0,1,2.828,0l1.343,1.343A2,2,0,0,1,17.308,6.757Z"
                  transform="translate(0 0)"
                  fill="var(--app-primary)"
                />
              </svg>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="container mt-5">
    <div class="clearfix"></div>

    <!-- Setting -->
    <Setting :id="1" :title="'المنطقة الزمنية'" :section_title="'بيانات الفريق'" :icon="require('@/assets/images/timezone.svg')" :status="true" :subtitle="'حدد الوقت الزمني لمواعيدك'" :visibility="true" :hasToggler="false">
      <div class="w-50 multiselect-custom-container">
        <Multiselect class=" form-control border-2 mutliselect-custom py-2 text-secondary"  v-model="value" :placeholder="'إختر'" :searchable="true" :options="options" />
      </div>
      <template v-slot:button><button class="btn btn-primary  rounded-pill mt-3 fw-bold">حفظ</button></template>
    </Setting>

    <Setting :id="2" :title="'وصف قصير'" :section_title="''" :icon="require('@/assets/images/details.svg')" :status="true" :subtitle="'وصف قصير عن الفريق'" :visibility="true" :hasToggler="false">
      <div>
        <textarea class="form-control h-100" placeholder="أكتب هنا ..." rows="3"></textarea>
      </div>
      <template v-slot:button><button class="btn btn-primary  rounded-pill mt-3 fw-bold">تعديل</button></template>
    </Setting>

    <Setting :id="2" :title="`أوقات الدوام `" :section_title="''" :icon="require('@/assets/images/schedule.svg')" :status="true" :subtitle="`اوقات الدوام معدة حسب المنطقة الزمنية<a href='#' class='text-primary'>لتعديل المنطقة الزمنية</a>`" :visibility="true" :hasToggler="false">
      <div class="accordion" id="accordionPanelsStayOpenExample">
        <div class="accordion-item card border-2 mb-3 p-3">
          <h2 class="accordion-header" id="panelsStayOpen-headingOne">
            <div class="switch-box primary d-flex align-items-center ms-auto">
              <input type="checkbox" id="collapseOne" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true" aria-controls="panelsStayOpen-collapseOne" />
              <label for="collapseOne">Toggle</label>
              <span class="fw-bold ms-3 fs-6">السبت</span>
            </div>
          </h2>
          <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingOne">
            <div class="accordion-body px-0">
              <div class="d-flex align-items-center">
                <div class="start-date">
                  <label for="">من</label>
                  <div class="pe-3 border-end">
                    <select name="" id="" class="form-select form-select-lg">
                      <option value="">إختر</option>
                      <option value="">12:00</option>
                      <option value="">12:30</option>
                      <option value="">1:00</option>
                    </select>
                  </div>
                </div>
                <div class="end-date">
                  <label for="" class="ps-lg-3 fs-14px">إلى</label>
                  <div class="ps-3">
                    <select name="" id="" class="form-select form-select-lg">
                      <option value="">إختر</option>
                      <option value="">12:00</option>
                      <option value="">12:30</option>
                      <option value="">1:00</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="accordion-item card border-2 mb-3 p-3">
          <h2 class="accordion-header" id="panelsStayOpen-headingTwo">
            <div class="switch-box primary d-flex align-items-center ms-auto">
              <input type="checkbox" id="collapseTwo" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="true" aria-controls="panelsStayOpen-collapseTwo" />
              <label for="collapseTwo">Toggle</label>
              <span class="fw-bold ms-3 fs-6">الأحد</span>
            </div>
          </h2>
          <div id="panelsStayOpen-collapseTwo" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingTwo">
            <div class="accordion-body px-0">
              <div class="d-flex align-items-center">
                <div class="start-date">
                  <label for="" class="fs-14px">من</label>
                  <div class="pe-3 border-end">
                    <select name="" id="" class="form-select form-select-lg">
                      <option value="">إختر</option>
                      <option value="">12:00</option>
                      <option value="">12:30</option>
                      <option value="">1:00</option>
                    </select>
                  </div>
                </div>
                <div class="end-date">
                  <label for="" class="ps-lg-3 fs-14px">إلى</label>
                  <div class="ps-3">
                    <select name="" id="" class="form-select form-select-lg">
                      <option value="">إختر</option>
                      <option value="">12:00</option>
                      <option value="">12:30</option>
                      <option value="">1:00</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="accordion-item card border-2 mb-3 p-3">
          <h2 class="accordion-header" id="panelsStayOpen-headingThree">
            <div class="switch-box primary d-flex align-items-center ms-auto">
              <input type="checkbox" id="collapseThree" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseThree" aria-expanded="true" aria-controls="panelsStayOpen-collapseThree" />
              <label for="collapseThree">Toggle</label>
              <span class="fw-bold ms-3 fs-6">الاثنين</span>
            </div>
          </h2>
          <div id="panelsStayOpen-collapseThree" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingThree">
            <div class="accordion-body px-0">
              <div class="d-flex align-items-center">
                <div class="start-date">
                  <label for="" class="fs-14px">من</label>
                  <div class="pe-3 border-end">
                    <select name="" id="" class="form-select form-select-lg">
                      <option value="">إختر</option>
                      <option value="">12:00</option>
                      <option value="">12:30</option>
                      <option value="">1:00</option>
                    </select>
                  </div>
                </div>
                <div class="end-date">
                  <label for="" class="ps-lg-3 fs-14px">إلى</label>
                  <div class="ps-3">
                    <select name="" id="" class="form-select form-select-lg">
                      <option value="">إختر</option>
                      <option value="">12:00</option>
                      <option value="">12:30</option>
                      <option value="">1:00</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="accordion-item card border-2 mb-3 p-3">
          <h2 class="accordion-header" id="panelsStayOpen-headingFour">
            <div class="switch-box primary d-flex align-items-center ms-auto">
              <input type="checkbox" id="collapseFour" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseFour" aria-expanded="true" aria-controls="panelsStayOpen-collapseFour" />
              <label for="collapseFour">Toggle</label>
              <span class="fw-bold ms-3 fs-6">الثلاثاء</span>
            </div>
          </h2>
          <div id="panelsStayOpen-collapseFour" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingFour">
            <div class="accordion-body px-0">
              <div class="d-flex align-items-center">
                <div class="start-date">
                  <label for="" class="fs-14px">من</label>
                  <div class="pe-3 border-end">
                    <select name="" id="" class="form-select form-select-lg">
                      <option value="">إختر</option>
                      <option value="">12:00</option>
                      <option value="">12:30</option>
                      <option value="">1:00</option>
                    </select>
                  </div>
                </div>
                <div class="end-date">
                  <label for="" class="ps-lg-3 fs-14px">إلى</label>
                  <div class="ps-3">
                    <select name="" id="" class="form-select form-select-lg">
                      <option value="">إختر</option>
                      <option value="">12:00</option>
                      <option value="">12:30</option>
                      <option value="">1:00</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="accordion-item card border-2 mb-3 p-3">
          <h2 class="accordion-header" id="panelsStayOpen-headingFive">
            <div class="switch-box primary d-flex align-items-center ms-auto">
              <input type="checkbox" id="collapseFive" checked data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseFive" aria-expanded="true" aria-controls="panelsStayOpen-collapseFive" />
              <label for="collapseFive">Toggle</label>
              <span class="fw-bold ms-3 fs-6">الأربعاء</span>
            </div>
          </h2>
          <div id="panelsStayOpen-collapseFive" class="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingFive">
            <div class="accordion-body px-0">
              <div class="d-flex align-items-center">
                <div class="start-date">
                  <label for="" class="fs-14px">من</label>
                  <div class="pe-3 border-end">
                    <select name="" id="" class="form-select form-select-lg">
                      <option value="">إختر</option>
                      <option value="">12:00</option>
                      <option value="">12:30</option>
                      <option value="">1:00</option>
                    </select>
                  </div>
                </div>
                <div class="end-date">
                  <label for="" class="ps-lg-3">إلى</label>
                  <div class="ps-3">
                    <select name="" id="" class="form-select form-select-lg">
                      <option value="">إختر</option>
                      <option value="">12:00</option>
                      <option value="">12:30</option>
                      <option value="">1:00</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="accordion-item card border-2 p-3">
          <h2 class="accordion-header" id="panelsStayOpen-headingSix">
            <div class="switch-box primary d-flex align-items-center ms-auto">
              <input type="checkbox" id="collapseSix" checked data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseSix" aria-expanded="true" aria-controls="panelsStayOpen-collapseSix" />
              <label for="collapseSix">Toggle</label>
              <span class="fw-bold ms-3 fs-6">الخميس</span>
            </div>
          </h2>
          <div id="panelsStayOpen-collapseSix" class="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingSix">
            <div class="accordion-body px-0">
              <div class="d-flex align-items-center">
                <div class="start-date">
                  <label for="" class="fs-14px">من</label>
                  <div class="pe-3 border-end">
                    <select name="" id="" class="form-select form-select-lg">
                      <option value="">إختر</option>
                      <option value="">12:00</option>
                      <option value="">12:30</option>
                      <option value="">1:00</option>
                    </select>
                  </div>
                </div>
                <div class="end-date">
                  <label for="" class="ps-lg-3 fs-14px">إلى</label>
                  <div class="ps-3">
                    <select name="" id="" class="form-select form-select-lg">
                      <option value="">إختر</option>
                      <option value="">12:00</option>
                      <option value="">12:30</option>
                      <option value="">1:00</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Setting>

    <Setting :id="3" :title="'أعضاء الفريق'" :section_title="''" :icon="require('@/assets/images/users.svg')" :status="true" :subtitle="'يمكنك إستخدام الفريق اذا احتجت'" :visibility="true" :hasToggler="false">
      <UserCard :classes="'d-flex bg-secondary align-items-center gap-2 p-2 bg-light team-card border border-2 mb-2'" v-for="user in users" :key="user.id" :user="user" />
      <div class="py-2">
        <button data-bs-toggle="modal" data-bs-target="#inviteModal" class="btn btn-outline-primary rounded-pill py-2 px-3 d-flex gap-2">
          <div class="svg-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
              <g id="plus" transform="translate(-4 -4)">
                <path id="Line_1" data-name="Line 1" d="M-.086,13A.9.9,0,0,1-1,12.125V-.125A.9.9,0,0,1-.086-1a.9.9,0,0,1,.914.875v12.25A.9.9,0,0,1-.086,13Z" transform="translate(11.086 5)" fill="currentColor" />
                <path id="Line_2" data-name="Line 2" d="M12.125.828H-.125A.9.9,0,0,1-1-.086.9.9,0,0,1-.125-1h12.25A.9.9,0,0,1,13-.086.9.9,0,0,1,12.125.828Z" transform="translate(5 11.086)" fill="currentColor" />
              </g>
            </svg>
          </div>
          دعوة حساب للفريق
        </button>
      </div>
      <template v-slot:button><button class="btn btn-primary  rounded-pill mt-3 fw-bold">حفظ</button></template>
    </Setting>

    <Setting :id="6" :title="'حذف الحساب'" :section_title="'المنطقة الخطرة'" :icon="require('@/assets/images/trash2.svg')" :status="true" :subtitle="`نحزن كثيرا في حال قيامك بهذا الامر إن كان لديك اي استفسار او مشكلة <a href='#' class='text-primary'>تواصل معنا</a>`" :visibility="true" :hasToggler="false">
      <button class="btn text-decoration-underline gap-2 text-danger d-flex align-items-center p-0">
        <div class="svg-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="20.225" height="20.225" viewBox="0 0 20.225 20.225">
            <g id="Group_1295" data-name="Group 1295" transform="translate(-2 -2)">
              <path id="Path_67" data-name="Path 67" d="M10.011,10a1.011,1.011,0,0,1,1.011,1.011v5.056a1.011,1.011,0,1,1-2.022,0V11.011A1.011,1.011,0,0,1,10.011,10Z" transform="translate(0.079 0.09)" fill="currentColor" fill-rule="evenodd" />
              <path id="Path_68" data-name="Path 68" d="M14.011,10a1.011,1.011,0,0,1,1.011,1.011v5.056a1.011,1.011,0,1,1-2.022,0V11.011A1.011,1.011,0,0,1,14.011,10Z" transform="translate(0.124 0.09)" fill="currentColor" fill-rule="evenodd" />
              <path
                id="Path_69"
                data-name="Path 69"
                d="M10.09,2A3.034,3.034,0,0,0,7.056,5.034H3.011a1.011,1.011,0,0,0,0,2.022H4.022V19.191a3.034,3.034,0,0,0,3.034,3.034H17.168A3.034,3.034,0,0,0,20.2,19.191V7.056h1.011a1.011,1.011,0,1,0,0-2.022H17.168A3.034,3.034,0,0,0,14.135,2Zm5.056,3.034a1.011,1.011,0,0,0-1.011-1.011H10.09A1.011,1.011,0,0,0,9.079,5.034ZM7.056,7.056H6.045V19.191A1.011,1.011,0,0,0,7.056,20.2H17.168a1.011,1.011,0,0,0,1.011-1.011V7.056H7.056Z"
                fill="currentColor"
                fill-rule="evenodd"
              />
            </g>
          </svg>
        </div>
        حذف الحساب وجميع البيانات
      </button>
    </Setting>
  </div>

  <Modal :form_img="false" :modal_img="require('@/assets/images/msaaq.svg')" :close_btn_color="'white'" :modal_title="'دعوة حساب'" :name="'invite'">
    <form>
      <div class="mb-3">
        <label>البريد</label>
        <input type="email" class="form-control text-secondary" placeholder="Msaaq@example.com" />
      </div>
      <div class="border border-1 my-4"></div>
      <div>
        <h6 class="fs-6 fw-bold">الرتبة</h6>
        <div class="radio-group radio-with-text-2 btn-group d-flex flex-column gap-2" role="group" aria-label="Basic radio toggle button group">
          <div class="position-relative">
            <input type="radio" class="form-check-input bg-transparent" name="btnradio" id="btnradio1" autocomplete="off" />
            <label class="btn btn-outline-primary text-start w-100 d-flex align-items-center gap-4" for="btnradio1">
              <div></div>
              <div class="d-flex flex-column">
                <h5 class="text-black fw-bold fs-6">مسؤول</h5>
                <span class="fs-14px text-secondary">بإمكانه تعديل كل شيء</span>
              </div>
            </label>
          </div>
          <div class="position-relative">
            <input type="radio" class="form-check-input bg-transparent" name="btnradio" id="btnradio2" autocomplete="off" />
            <label class="btn btn-outline-primary text-start w-100 d-flex align-items-center gap-4" for="btnradio2">
              <div></div>
              <div class="d-flex flex-column">
                <h5 class="text-black fw-bold fs-6">محرر</h5>
                <span class="fs-14px text-secondary">بإمكانه التعديل على المواعيد</span>
              </div>
            </label>
          </div>
        </div>
      </div>
      <div class="d-grid">
        <button class="btn btn-primary rounded-pill py-2 mt-4">إضافة</button>
      </div>
    </form>
  </Modal>
</template>

<script>
import {ref} from '@vue/reactivity'
import Setting from '../components/Setting.vue'
import UserCard from '../components/UserCard.vue'
import Modal from '../components/Modal.vue'
import Multiselect from '@vueform/multiselect'

export default {
  name: 'Team',
  components: {Setting, UserCard, Modal, Multiselect},
  setup() {
    const value = ref(null)
    const options = ref(['GMT', 'UTC'])
    const users = ref([
      {
        id: 1,
        email: 'medhataudeh@gmail.com',
        permission: 'Admin',
      },
      {
        id: 2,
        email: 'hussam3bd@gmail.com',
        permission: 'Admin',
      },
    ])

    return {users, value, options}
  },
}
</script>

<style>
</style>